module.exports = __webpack_public_path__ + "img/Caravan-Outline.c45568f6.png";